<template>
  <div :class="['main-content','sn-content',heightC]">
      <el-form ref="form" :model="form" :rules="rules">
        <div v-if="user.partnerFlag == '1' && partnerSnCnt < 10">
          <p style="text-align: left;margin-top: 20px">免费使用</p>
          <div class="box-card is-always-shadow">
            <el-form-item label="" class="pxy-form-item pxy-form-item-line" >
              <div class="pxy-tag-label">
                <span style="width: 210px">使用免费行业伙伴授权</span>
                <el-checkbox  v-model="form.partnerFlag" @change="changePartnerFlag($event)" ></el-checkbox>

              </div>
              <el-tag type="warning">*开通行业伙伴授权，可以免费使用授权，不可商业使用，最多可申请10个，已申请{{partnerSnCnt}}个</el-tag>
            </el-form-item>
          </div>
        </div>


        <div class="box-card clearfix" style="padding-top: 10px">
          <el-form-item label="" prop="maxConnCnt">
            <div class="pxy-tag-label">
              <span>并发数：</span>
            </div>
            <el-input  placeholder="" v-model="form.maxConnCnt" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="" prop="endDate">
            <div class="pxy-tag-label">
              <span>结束日期：</span>
            </div>
            <el-date-picker
              v-model="form.endDate"
              value-format="yyyy-MM-dd HH:mm:ss"
              align="right"
              type="datetime"
              placeholder="选择日期">
            </el-date-picker>
            <el-tooltip effect="light" placement="top-start">
              <p slot="content" class="tip-info" style="max-width: 900px">针对测试用户，我们可以在提升并发量的同时，设定一个合理的有效期限制。
                这样做是为了避免长时间无限制地使用高并发使用。请留意，一旦有效期截止，相应的授权码将失效。 </p>
              <i class="el-icon-question tip-icon"></i>
            </el-tooltip>
          </el-form-item>

          <el-form-item label="" prop="tag">
            <div class="pxy-tag-label">
              <span>业务区分：</span>
            </div>
            <el-input disabled placeholder="业务区分，10个字符以内，例如项目名" v-model="form.tag" style="width:300px"></el-input>
          </el-form-item>

          <el-form-item  v-for="(item, index) in (form.partnerFlag ? partnerItemList : commItemList)"
                         label="" class="pxy-form-item pxy-form-item-line">
            <div class="pxy-tag-label">
              <span>{{item.itemName}}：</span>
              <el-checkbox v-if="item.required == '1'" checked="checked" disabled :key="item.id" v-model="item.checkStatus">必选</el-checkbox>
              <el-checkbox disabled v-else @change="changeContentHeight($event)" :key="item.id"  v-model="item.checkStatus"></el-checkbox>
            </div>
            <el-tag v-if="item.note" type="warning" v-html="item.note"></el-tag>
          </el-form-item>

        </div>

      </el-form>
      <div class="price-detail">
        <div class="item ">
          <div  v-for="(item, index) in (form.partnerFlag ? partnerItemList : commItemList)" v-if="item.checkStatus">
            <span class="title">{{item.itemName}}：</span>
            <span class="unit">￥</span>
            <span class="price">{{item.price}}</span>
            <span class="unit"> {{item.priceUnit}}</span>
          </div>
        </div>
        <div  class="item" style="">
          <el-button type="primary" class="pxy-primary" plain @click="updateSn()">修改</el-button>
        </div>

      </div>

  </div>
</template>

<script>
  import {Message} from "element-ui";

  export default {
    components: {},
    data() {
      return {
        id: this.$route.query.id,
        loading: false,
        cloudSnProdItemList: [], //所有的计价规则
        commItemList: [], //通用计价规则
        partnerItemList: [], //行业伙伴计价规则
        cloudSn:{},
        form: {
          serviceItemList:[],
          tag:'',
          maxConnCnt:'',
          endDate:'',
          partnerFlag: false,
        },
        rules: {
          tag: [{required: true, message: '请输入业务区分', trigger: 'blur'}, {max: 10, message: "长度在10个字符以内", trigger: 'blur'}],},
        //内容的整体高度class
        heightC: 'heightN0',
        //增值服务的开启数量
        extraCnt: 0,
        //行业伙伴的授权数量
        partnerSnCnt:0,
      }
    },
    created() {
    },
    methods: {
      getProcProdItem: function () {
        this.getRequest('/pocPriceItem/list', {"type": 1}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.cloudSnProdItemList = resp.data.result;
              this.commItemList = this.cloudSnProdItemList.filter(item => item.prodId == '876867839321964544');
              this.partnerItemList = this.cloudSnProdItemList.filter(item => item.prodId == '876867839321964545');
              this.commItemList.forEach((item, index) => {
                this.$set(item, 'checkStatus', false);
              })
              this.partnerItemList.forEach((item, index) => {
                this.$set(item, 'checkStatus', false);
              })
              //获取到价格列表之后再去获取云授权码
              this.getCloudSnInfo()
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      updateSn: function () {
        var params = {};
        params.tag = this.form.tag;
        params.orderId = this.cloudSn.orderId;
        params.sn = this.cloudSn.sn;
        params.id = this.id;
        params.maxConnCnt = this.form.maxConnCnt;
        if(this.form.endDate){
          params.endDate = new Date(this.form.endDate).getTime();
        }
       // params.serviceItemList = this.user.partnerFlag && this.form.partnerFlag ? this.partnerItemList.filter(item => item.checkStatus) : this.commItemList.filter(item => item.checkStatus);
        this.$refs["form"].validate((valid) => {
          if (valid) {
            var that = this;
            this.$confirm('针对测试用户，我们可以在提升并发量的同时，设定一个合理的有效期限制。\n' +
              '                这样做是为了避免长时间无限制地使用高并发使用。请留意，一旦有效期截止，相应的授权码将失效。', '温馨提示', {
              confirmButtonText: '更新',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }).then(() => {
              that.doUpdate(params);
            }).catch(() => {

            });

          }
        })
      },
      doUpdate:function(params){
        this.loading = true;
        this.postRequestJson('/pocCloudSn/admin/update', JSON.stringify(params)).then(resp => {
          this.loading = false;
          if (resp && resp.status == 200) {
            var data = resp.data;
            if (data.code == 1000) {
              Message.success(data.message);
              this.form = {
                dcsFlag: false,
                playModeFlag: false,
                vrClassFlag: false,
                instanceMax: 5,
                tag: ''
              }
              this.$router.replace({path: '/userManage/sn', query:{
                  userId: this.$route.query.userId,
                  userName: this.$route.query.userName
                }
              });

            } else {
              Message.error(data.message);

            }
          }
        });
      },
      changeContentHeight: function (flag) {
        if (flag) {
          this.extraCnt += 1;
        } else {
          this.extraCnt -= 1;
        }
        this.heightC = 'heightN' + this.extraCnt;
      },
      getCloudSnInfo: function () {
        this.getRequest('/pocCloudSn/list', {id:this.id, page:1, pageSize: 20}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.cloudSn = resp.data.result.records[0];
              this.form.tag = this.cloudSn.tag
              this.form.partnerFlag = this.cloudSn.wm == '3'
              this.form.maxConnCnt = this.cloudSn.maxConnCnt
              this.form.endDate = new Date(parseInt(this.cloudSn.endDate))

              //勾选之前选中的增值服务项
              const itemIdArray = this.cloudSn.orderDetailList.map(item => item.itemId);
              if(!this.form.partnerFlag){
                this.commItemList.forEach((item, index) => {
                  if(itemIdArray.includes(item.id)){
                    this.changeContentHeight(true)
                    this.$set(item, 'checkStatus', true);
                  }
                })
              }else {
                this.partnerItemList.forEach((item, index) => {
                  if(itemIdArray.includes(item.id)){
                    this.changeContentHeight(true)
                    this.$set(item, 'checkStatus', true);
                  }
                })
              }
            }
          }
        })
      },
      changePartnerFlag:function (flag) {
      },
      getPartnerSnCnt:function () {
        var params = {};
        params.wm = "3";
        params.status = "0";
        params.page = 1;
        params.pageSize = 20;
        params.userId = this.user.userId
        this.getRequest('/pocCloudSn/list', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.partnerSnCnt = resp.data.result.total;
            }}});
      }
    }
    ,
    mounted: function () {
      this.getProcProdItem();

      //如果用户符合开通行业伙伴授权的权限，查询行业伙伴授权开通了多少个
      if(this.user.partnerFlag == '1'){
        this.getPartnerSnCnt();
      }
    }
    ,
    computed: {
      user() {
        return this.$store.state.user;
      },
    },
    beforeDestroy() {

    }
  }
</script>
<style scoped>
.sn-content .pxy-form-item .el-checkbox{
  float: none;
}
.box-card {
  text-align: left;
    border: 1px solid #EBEEF5;
    background-color: #FFF;
    color: #303133;
    border-radius: 4px;
    /* padding: 20px; */

}
@media screen and (max-width: 768px) {
  /* 1px solid #EBEEF5 */
  .pxy-form-item .el-form-item__content .el-tag {
    height: auto!important;
    white-space: normal!important;
  }
  .pxy-form-item {
    margin-bottom: 10px!important;
    padding-bottom: 15px!important;
    box-sizing: border-box!important;
  }
  .pxy-form-item-line {
    border-bottom: 1px solid #EBEEF5!important;
  }
}

@media screen and (min-width: 769px) {
  .pxy-form-item .el-form-item__content {
    margin-left: 0!important;
  }
  .pxy-form-item .el-form-item__content .el-tag {
    margin-left: 10px!important;
  }
  .pxy-tag-label {
    display: inline-block;
  }
}
</style>
